const pricingDetails =[
    {
        id: 1,
        planName: "Monthly",
        planPrice: "₹999",
        features:["Official API", "Autodialer", "Call recording", "Excel upload", "Follow-ups" , "Tracking", "Reminder", "chatbot", "Templates", "Broadcasting"]
    },
    {
        id: 2,
        planName: "Quarterly",
        planPrice: "₹2,299",
        features:["Official API", "Autodialer", "Call recording", "Excel upload", "Follow-ups" , "Tracking", "Reminder", "chatbot", "Templates", "Broadcasting"]
    },
    {
        id: 3,
        planName: "Annually",
        planPrice: "₹10,999",
        features:["Official API", "Autodialer", "Call recording", "Excel upload", "Follow-ups" , "Tracking", "Reminder", "chatbot", "Templates", "Broadcasting"]
    }
]

export default pricingDetails;